document.addEventListener('turbo:load', function () {
  const streamElements = document.querySelectorAll('turbo-cable-stream-source');

  streamElements.forEach((element) => {
    element.addEventListener('message', function (event) {
      const data = event.data;

      if (data && data.action === 'reprocess_complete') {
        handleReprocessComplete(data);
      } else if (data && data.action === 'reprocess_error') {
        handleReprocessError(data);
      }
    });
  });
});

function handleReprocessComplete(data) {
  if (data.vin_number && window.location.pathname.includes(data.vin_number.toLowerCase())) {
    Turbo.visit(window.location.href, { action: 'replace' });
  }
}

function handleReprocessError(data) {
  if (data.vin_number && window.location.pathname.includes(data.vin_number.toLowerCase())) {
    alert('Unable to load detailed VIN information. Please try refreshing the page.');
  }
}
